export default "__VITE_ASSET__DRZuGyLM__"